import { tv } from 'tailwind-variants'

export const stepper = tv({
  slots: {
    progressIndicatorContainer: 'relative flex w-2.5 flex-grow-0 flex-col items-center',
    progressIndicator:
      'absolute top-0 z-10 flex h-[30px] w-[30px] items-center justify-center rounded-full border',
    progressLine: 'w-[2px] flex-grow bg-grey-200',
    textContainer: 'ml-6 shrink pb-6',
  },
  variants: {
    pastStep: {
      true: {
        progressIndicator: 'border-success bg-success',
        progressLine: 'bg-success',
      },
    },
    currentStep: {
      true: {
        progressIndicator: 'border-success bg-success-light',
      },
    },
    pendingStep: {
      true: {
        progressIndicator: 'border-grey-300 bg-white',
      },
    },
    lastStep: {
      true: {
        progressLine: 'h-1 flex-grow-0',
        textContainer: 'pb-0',
      },
    },
  },
  defaultVariants: {
    pastStep: false,
    currentStep: false,
    pendingStep: false,
    lastStep: false,
  },
})
